import { render } from "./Caution.vue?vue&type=template&id=3f1560a6&scoped=true"
import script from "./Caution.vue?vue&type=script&lang=js"
export * from "./Caution.vue?vue&type=script&lang=js"

import "./Caution.vue?vue&type=style&index=0&id=3f1560a6&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1560a6"]])

export default __exports__